var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "reporting-hierarchy-cell-renderer" }, [
    _c(
      "div",
      { staticClass: "hierarchy-name" },
      [
        _vm.hierarchyName.type === "text"
          ? [_vm._v("\n      " + _vm._s(_vm.hierarchyName.text) + "\n    ")]
          : _vm.hierarchyName.type === "link"
          ? [
              _c("span", { staticClass: "workpackage-link-container" }, [
                _c("span", [_vm._v(_vm._s(_vm.hierarchyName.text))]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "workpackage-link",
                    attrs: {
                      href: `/pricing/desk-view/workpackage/${_vm.hierarchyName.linkData.wpId}`,
                      target: "_blank",
                      title: _vm.$t("reporting.config.openWorkpackage", {
                        name:
                          _vm.hierarchyName.linkData.wpName ||
                          _vm.hierarchyName.linkData.wpId,
                      }),
                    },
                  },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.hierarchyName.linkData.wpName ||
                            _vm.hierarchyName.linkData.wpId
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("i", { staticClass: "mdi mdi-open-in-new" }),
                  ]
                ),
              ]),
            ]
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }